"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseFeaturesContext = exports.baseContext = exports.baseConfig = exports.PLUGINS = void 0;
const google_analytics_1 = __importDefault(require("@analytics/google-analytics")); // https://github.com/DavidWells/analytics/tree/master/packages/analytics-plugin-google-analytics
const google_tag_manager_1 = __importDefault(require("@analytics/google-tag-manager")); //https://github.com/DavidWells/analytics/tree/master/packages/analytics-plugin-google-tag-manager
const config_1 = require("config");
/**
 * Plugins
 */
exports.PLUGINS = {
    'credit-portal': [
        config_1.REACT_APP_ANALYTICS_CFE_GA_ID
            ? (0, google_analytics_1.default)({
                measurementIds: [config_1.REACT_APP_ANALYTICS_CFE_GA_ID],
            })
            : null,
        config_1.REACT_APP_ANALYTICS_CFE_GTM_ID
            ? (0, google_tag_manager_1.default)({
                containerId: config_1.REACT_APP_ANALYTICS_CFE_GTM_ID,
            })
            : null,
    ].filter((itm) => itm),
    'merchant-portal': [
        config_1.REACT_APP_ANALYTICS_MFE_GA_ID
            ? (0, google_analytics_1.default)({
                measurementIds: [config_1.REACT_APP_ANALYTICS_MFE_GA_ID],
            })
            : null,
        config_1.REACT_APP_ANALYTICS_MFE_GTM_ID
            ? (0, google_tag_manager_1.default)({
                containerId: config_1.REACT_APP_ANALYTICS_MFE_GTM_ID,
            })
            : null,
    ].filter((itm) => itm),
};
/**
 * Base Config
 */
exports.baseConfig = {
    app: undefined,
    version: 1,
    debug: false,
    plugins: [],
};
/**
 * Base Context
 */
exports.baseContext = {
    analytics: null,
    setAppName: null,
};
/**
 * Base Context
 */
exports.baseFeaturesContext = {
    globalConfig: null,
};
